// Deep links into the Copilot widget.
//
//   /?copilot=<conversationId>                  signed-in users (and returning guests)
//   /?copilot=<conversationId>#access=<token>   guest links in e-mails: the token is
//        single-use, short lived and only ever travels in the URL fragment, so it
//        is not sent to any server or written to access logs. It is read once and
//        removed from the address bar immediately.
//
// The same widget can be opened from inside the app (a notification click) with
// the COPILOT_OPEN_EVENT.

export const COPILOT_OPEN_EVENT = "lud-copilot-open";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function openCopilotConversation(conversationId) {
  window.dispatchEvent(new CustomEvent(COPILOT_OPEN_EVENT, { detail: { conversationId } }));
}

// Reads (and removes) the link parameters of the current address.
export function readLinkFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const conversationId = params.get("copilot");
    if (!conversationId) return null;
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const accessToken = hash.get("access");
    params.delete("copilot");
    hash.delete("access");
    const search = params.toString();
    const rest = hash.toString();
    window.history.replaceState(window.history.state, "", `${window.location.pathname}${search ? `?${search}` : ""}${rest ? `#${rest}` : ""}`);
    if (!UUID.test(conversationId)) return null;
    return { conversationId, accessToken: accessToken && accessToken.length <= 200 ? accessToken : null };
  } catch {
    return null;
  }
}

// Moves to an in-app route from code that is not inside a <Router> (a plain
// history push that BrowserRouter picks up through its popstate listener).
export function navigateInApp(path) {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
